import { render, staticRenderFns } from "./hazrat-masoomeh.vue?vue&type=template&id=39b645f4&"
import script from "./hazrat-masoomeh.vue?vue&type=script&lang=ts&"
export * from "./hazrat-masoomeh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports